import { render, staticRenderFns } from "./ProductSelectionPage.vue?vue&type=template&id=4d7275a6&scoped=true"
import script from "./ProductSelectionPage.vue?vue&type=script&lang=js"
export * from "./ProductSelectionPage.vue?vue&type=script&lang=js"
import style0 from "./ProductSelectionPage.vue?vue&type=style&index=0&id=4d7275a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7275a6",
  null
  
)

export default component.exports